module.exports = __webpack_public_path__ + "media/Footprints/Water-507a849f.svg";